import type { ReactNode } from 'react';

import { deliveryFieldLabel, formatDetailDate } from '../format';
import type { OrderDetail } from '../types';

import styles from './order-detail.module.scss';
import { OrderMetaRow } from './order-meta-row';

type Props = {
  order: OrderDetail;
  /** Phase 3: editable Expected Delivery control. Falls back to read-only text. */
  deliveryField?: ReactNode;
};

export function OrderDetailsCard({ order, deliveryField }: Props) {
  const { orderMeta, status } = order;
  const deliveryValue = status === 'delivered' ? order.deliveredAt : orderMeta.expectedDelivery;

  return (
    <section className={styles.card}>
      <h2 className={styles.cardTitle}>Order Details</h2>
      <dl className={styles.metaList}>
        <OrderMetaRow label="Order Date" value={formatDetailDate(orderMeta.orderDate)} />
        <OrderMetaRow label="Payment Method" value={orderMeta.paymentMethod} />
        <OrderMetaRow label="Payment Date" value={formatDetailDate(orderMeta.paymentDate)} />
        <OrderMetaRow
          label={deliveryFieldLabel(status)}
          value={deliveryField ?? formatDetailDate(deliveryValue)}
        />
        <OrderMetaRow label="Transaction ID" value={orderMeta.transactionId} />
      </dl>
    </section>
  );
}
